module.exports = __webpack_public_path__ + "static/img/tu4-m@2x.09509c8a.png";